import { render, staticRenderFns } from "./AppMenuIcon.vue?vue&type=template&id=624cbf35&scoped=true"
import script from "./AppMenuIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMenuIcon.vue?vue&type=style&index=0&id=624cbf35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624cbf35",
  null
  
)

export default component.exports